import React from 'react'
import { Row, Col, Button, Menu, Select} from 'antd'
import './bucket-cost-filter.scss'

const { Option } = Select


export default ({bucketCostData, on_bucket_change, on_bucket_usage_type_change, on_clear_filter_bucket_cost}) => {
    return (
    <div>

        <Row type='flex' gutter={5} justify='space-between' align='middle' className='filter-bucket-cost-container'>
            <Col span={24}>
                <Row type="flex">
                    <Col span={24}>
                        <div className='select-box'>
                            <Select
                                value = {bucketCostData && bucketCostData.selectedBucket && (bucketCostData.selectedBucket ? bucketCostData.selectedBucket.bucket_name : null)}
                                placeholder="Select a bucket"
                                size="large" dropdownMatchSelectWidth={false}
                                onSelect={on_bucket_change}>
                                <Option key={0} value={null}>
                                    Select a bucket
                                </Option>
                                {bucketCostData && bucketCostData.bucketCosts.map((bucket, index) =>
                                <Option key={bucket.bucket_name} value={bucket.bucket_name}>
                                    {bucket.bucket_name}
                                </Option>
                                )}
                            </Select>

                        </div>
                    </Col>
                </Row>
                <Row className="row-m-t">
                    <Col span={24}>
                        <div className='select-box'>

                            <Select
                                value = {bucketCostData.selectedUsageType ? bucketCostData.selectedUsageType.usage_type : null}
                                placeholder="Select a usage type"
                                size="large" dropdownMatchSelectWidth={false}
                                onSelect={on_bucket_usage_type_change}>
                                <Option key={0} value={null}>
                                    Select a usage type
                                </Option>
                                {bucketCostData && bucketCostData.selectedBucket && bucketCostData.selectedBucket.usage_types &&
                                bucketCostData.selectedBucket.usage_types.map((usageType, index) =>
                                (usageType.cost > 0.000001) && (<Option key={usageType.usage_type} value={usageType.usage_type}>
                                    {usageType.usage_type}
                                </Option>)
                                )}
                            </Select>


                        </div>
                    </Col>
                </Row>
                <Row className="row-m-t">
                    <Col span={24}>
                        <Button className="btn-filter" type='primary' size="large" htmlType='button' onClick={on_clear_filter_bucket_cost}>Clear Filter</Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
)}


const menuYear = (
    <Menu onClick={(e) => {}}>
      <Menu.Item key="1">2017</Menu.Item>
      <Menu.Item key="2">2016</Menu.Item>
    </Menu>
  )

const menuMonth = (
    <Menu onClick={(e) => {}}>
      <Menu.Item key="1">Augest</Menu.Item>
      <Menu.Item key="2">September</Menu.Item>
      <Menu.Item key="3">October</Menu.Item>
    </Menu>
  )
